import { getValidAccessToken } from './token'

export async function authFetch(url, options) {
    const bearerToken = await getValidAccessToken();
    const headers = options && options.headers ? options.headers : {};
    return await fetch(url, {
        ...options,
        headers: {
            ...headers,
            Authorization: `Bearer ${bearerToken}`
        }
    })
}

export default authFetch;
